import React from 'react';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import {Separator} from 'views/AppElements';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, RadioButton} from 'views/FormElements';

import UserAPI from 'service/api/UserAPI';

const UserTypeInfo = {"DESIGNER": "You are an independent artists and have digital designs that can be printed on various merchandise.", 
						"INFLUENCER": "You are an influencer with at least 5k+ followers in any of the popular social media platform.",
						"MERCHANT": "You are an independent seller with various designs or items."}

const Form = ({isSubmitting, values}) => {
	let submitBtn = "Create Account";
		
	if(isSubmitting === true)
			submitBtn = <span>Creating <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;
	
	const setupStore = values.userType === "INFLUENCER" || values.userType === "MERCHANT";
	return <RGForm>
			<h3 style={{fontStyle: "italic", margin: "10px 0 25px 0", textAlign: "center", color: 'gray'}}>Please fill in the form below to register.</h3>
			<Separator style={{margin: '20px auto', width: '30%'}} />

			<Input name="username" placeholder="E.g: Ram Prasad Jhilke" type="text" label="Fullname: " style={{marginBottom: "0px", marginTop: "10px"}}/>

			<div style={{marginBottom: '10px'}}>
				<label>Join As:</label>
				<div className='flexRow' style={{marginBottom: '0px'}} id="joinAsRadioBtnGroup">
					<RadioButton style={{flexGrow: '1'}} name="userType" value={"DESIGNER"} 
										label={<span style={{color: '#596161'}}>Artist </span>} 
										checked={values.userType === "DESIGNER"} />

					<RadioButton style={{flexGrow: '1'}} name="userType" value={"INFLUENCER"} 
									label={<span style={{color: '#596161'}}>Influencer</span>} 
									checked={values.userType === "INFLUENCER"} />


					<RadioButton style={{flexGrow: '1'}} name="userType" value={"MERCHANT"} 
									label={<span style={{color: '#596161'}}>Merchant</span>} 
									checked={values.userType === "MERCHANT"} />
				</div>

				{
					values.userType &&
					<div id="artistTypeInfo" className="flexRow">
						<i className="fa fa-exclamation-circle" style={{marginRight: '5px'}} aria-hidden="true"></i> 
						<label>{UserTypeInfo[values.userType]}</label>
					</div>
				}
			</div>

			{setupStore && <Input name="storeName" placeholder="Name of your store" type="text" label="Store Name: " style={{marginBottom: "0px"}}/> }
			<TextArea placeholder={"Max 100 characaters"} label={setupStore? "About Store:": "About you:"}  name="about" rows="3"/>

			<Separator style={{margin: '40px auto', width: '30%'}} />

			<Input name="phoneNumber" type="number" label="Phone Number (10 digit):" placeholder="E.g. 9862441133" style={{marginBottom: "0px"}} />
			<Input name="email" placeholder="E.g: somename@example.com" type="text" label="Email: " style={{marginBottom: "0px"}}/>

			<Input name="password" placeholder="E.g: 123456789 :)" type="password" label="Password: " style={{marginBottom: "0px", marginTop: "10px"}}/>


			
			<Separator style={{margin: '50px auto', width: '30%'}} />
			<h3>Social Media Accounts: <span style={{fontSize: "70%"}}>(Provide at least one)</span> </h3>
								
			<Input name="facebookUrl" label="Facebook:" type="text" placeholder="Enter your Facebook URL" style={{marginTop: '5px' }} />
			<Input name="instaUrl" label="Instagram:"  type="text" placeholder="Enter your Instagram URL" style={{marginTop: '5px' }} />
			<Input name="tiktokUrl" label="Tiktok:" type="text" placeholder="Enter your Tiktok URL" style={{marginTop: '5px' }} />
			<Input name="ytUrl" label="Youtube:" type="text" placeholder="Enter your Youtube URL" style={{marginTop: '5px' }} />
			<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
				{submitBtn}
			</SubmitButton>
	</RGForm>
};


class ArtistRegisterPage extends React.Component {

	constructor(props) {
		super(props);
		this.INIT_VALUES = {username: '', password: '', email: '', userType: '', 
							storeName: '', about:'', phoneNumber: '',
							facebookUrl: '',
							instaUrl: '',
							ytUrl: '',
							tiktokUrl: ''
							};

		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
			username: Yup.string().required('Enter your name'),
			email: Yup.string().email('Invalid Email address').required("Enter your email address"),
			userType: Yup.string().required('Select what kind of artist you are'),
			phoneNumber: Yup.string().required('Enter your phone').max(10, "Enter your 10 digit number"),
		    password: Yup.string().required('Enter a password').min(6, "Password cannot be less than 8 characters"),
			about: Yup.string().max(100, 'Max. 100 characters'),
			tiktokUrl: Yup.string(),
			instaUrl: Yup.string(),
			facebookUrl: Yup.string(),
			ytUrl: Yup.string().when(['tiktokUrl', 'instaUrl', 'facebookUrl'], (tiktokUrl, instaUrl, facebookUrl, schema) => {
				if(!tiktokUrl && !instaUrl && !facebookUrl)
					return Yup.string().required('Provide at least your one social media account');

				return Yup.string();
			})
		});
	}

	handleFormSubmission(values, {setSubmitting, resetForm}) {
		const registerRequest = {username: values.username, emailAddress: values.email, 
                                password: btoa(values.password),
								userType: values.userType,
								phoneNumber: values.phoneNumber,
								storeName: values.storeName? values.storeName.replace(/-/g, " "): '',
								about: values.about
								};

		const socialMediaAccounts = {};

		if(values.facebookUrl) socialMediaAccounts['FB'] = values.facebookUrl;
		if(values.instaUrl) socialMediaAccounts['INSTA'] = values.instaUrl;
		if(values.ytUrl) socialMediaAccounts['YOUTUBE'] = values.ytUrl;
		if(values.tiktokUrl) socialMediaAccounts['TIKTOK'] = values.tiktokUrl;

		registerRequest['socialMediaAccounts'] = socialMediaAccounts;

		UserAPI.register(registerRequest, function(success) {
			setSubmitting(false);
			
			if(success === true)
				resetForm(this.INIT_VALUES);
			
		}.bind(this));
	}

	render() {
		return <div id="artistSignUpPage">
			<SetoCanvasPage id="artistRegisterPage" title={"Nepals' Creative Artists Premium Hub | Seto Canvas"} 
			metaDescription={"Sign up as an Artist, Influencer or a Merchant today and get started with selling your merchandise online at SetoCanvas.com"}>

				<div id="artistSignUpForm">
					<Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
						validationSchema={this.validationScheme} component={Form} />
				</div>
			</SetoCanvasPage>
		</div>
	}
}

export default ArtistRegisterPage;


// WEBPACK FOOTER //
// ./src/pages/ArtistRegisterPage.js